module.exports = __webpack_public_path__ + "img/appended-outer-icon.1f187333.svg";